/**
 * Utility functions for exporting data to Excel format
 * Uses CSV format which can be opened in Excel
 */

export const exportToExcel = (data, filename = 'export.csv') => {
  if (!data || data.length === 0) {
    alert('No data to export');
    return;
  }

  // Get headers from first object
  const headers = Object.keys(data[0]);
  
  // Create CSV content
  let csvContent = headers.join(',') + '\n';
  
  data.forEach(row => {
    const values = headers.map(header => {
      const value = row[header];
      // Handle values with commas, quotes, or newlines
      if (value === null || value === undefined) {
        return '';
      }
      const stringValue = String(value);
      if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
        return `"${stringValue.replace(/"/g, '""')}"`;
      }
      return stringValue;
    });
    csvContent += values.join(',') + '\n';
  });

  // Create blob and download
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

/**
 * Export multiple sheets to Excel (as separate CSV files in a zip)
 * For simplicity, we'll create multiple CSVs
 */
export const exportMultipleSheets = async (sheetsData, baseFilename = 'export') => {
  // This would require a zip library for true Excel format
  // For now, export each sheet as separate CSV
  for (const [sheetName, data] of Object.entries(sheetsData)) {
    exportToExcel(data, `${baseFilename}_${sheetName}.csv`);
  }
};

/**
 * Format data for export with readable headers
 * headerMap keys determine the order and which fields are included
 */
export const formatDataForExport = (data, headerMap = {}) => {
  return data.map(row => {
    const formattedRow = {};
    // Iterate over headerMap keys to preserve order and only include specified fields
    for (const [key, displayKey] of Object.entries(headerMap)) {
      formattedRow[displayKey] = row[key] !== undefined ? row[key] : '';
    }
    return formattedRow;
  });
};
